import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { UPDATE_SITE_REGISTRATION } from './url-constants';

type UpdateSiteRegistrationEndpointSpecification = ApiEndpointSpecification;
export const UpdateSiteRegistrationEndpointSpecification: UpdateSiteRegistrationEndpointSpecification = {
    url: UPDATE_SITE_REGISTRATION,
    method: HttpMethod.PUT,
    requestParamsSchemaName: 'UpdateSiteRegistrationRequestParams',
    requestBodySchemaName: 'UpdateSiteRegistrationRequestBody',
    okResponseSchemaName: 'UpdateSiteRegistrationOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeUpdateSiteRegistration = Helpers.makeApiRequestFn<
    Types.UpdateSiteRegistrationRequestParams,
    Types.UpdateSiteRegistrationRequestBody,
    Types.UpdateSiteRegistrationOkResponse
>(UpdateSiteRegistrationEndpointSpecification);
